"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
/**
 * @todo remove $isModel
 *
 * Hack for model-systems before all buttons are migrated
 */
exports.FooterContainer = styled_components_1.default.div `
  position: absolute;
  bottom: 0;
  left: 0;

  display: flex;

  width: ${({ $isMobile, theme }) => $isMobile ? '100vw' : `calc(100vw - ${theme.mainMenuWidth}px)`};

  height: ${({ theme, $isModel }) => $isModel ? '' : `${theme.footerHeight}px`};

  background: ${({ theme }) => theme.backgroundWithOpacity};

  transition: transform 0.2s ease-in-out;

  &.enter {
    transform: translateY(100%);
  }

  &.enter-active {
    transform: translateY(0);
  }

  &.enter-done {
    transform: none;
  }

  &.exit {
    transform: translateY(0);
  }

  &.exit-active {
    transform: translateY(100%);
  }
`;
